import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

// 강화된 스크롤 함수 - 다른 컴포넌트에서도 사용 가능
export const scrollToTop = () => {
  const performScroll = () => {
    // 전체 페이지 스크롤 초기화
    window.scrollTo(0, 0);
    
    // 모바일 환경에서 body의 스크롤도 초기화
    document.body.scrollTop = 0;
    document.documentElement.scrollTop = 0;
    
    // App 컴포넌트의 메인 스크롤 컨테이너 찾기
    const appContainer = document.querySelector('.App > div:last-child');
    if (appContainer) {
      appContainer.scrollTop = 0;
    }
    
    // content-area가 있다면 그 스크롤도 초기화
    const contentArea = document.querySelector('.content-area');
    if (contentArea) {
      contentArea.scrollTop = 0;
    }
    
    // 추가적인 스크롤 컨테이너들 처리
    const scrollContainers = document.querySelectorAll('[style*="overflow: auto"], [style*="overflow-y: auto"], .main-content');
    scrollContainers.forEach(container => {
      container.scrollTop = 0;
    });
  };
  
  // 즉시 실행
  performScroll();
  
  // 페이지 이동 후에도 다시 실행 (타이밍 문제 해결)
  setTimeout(performScroll, 50);
  setTimeout(performScroll, 100);
};

export default function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    scrollToTop();
  }, [pathname]);

  return null;
} 